var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1143_2168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7293 2.04199H3.396C2.45319 2.04199 1.98178 2.04199 1.68889 2.31679C1.396 2.59159 1.396 3.03387 1.396 3.91843V4.37831C1.396 5.07021 1.396 5.41615 1.56906 5.70294C1.74213 5.98973 2.05831 6.16771 2.69068 6.52369L4.63269 7.61693C5.05697 7.85573 5.26911 7.97519 5.421 8.10706C5.73732 8.38166 5.93205 8.70433 6.02029 9.10013C6.06266 9.29013 6.06266 9.51253 6.06266 9.95726V11.7369C6.06266 12.3433 6.06266 12.6465 6.23061 12.8829C6.39856 13.1192 6.69685 13.2358 7.29346 13.4691C8.54586 13.9587 9.17207 14.2035 9.6174 13.9249C10.0627 13.6464 10.0627 13.0099 10.0627 11.7369V9.95726C10.0627 9.51253 10.0627 9.29013 10.1051 9.10013C10.1933 8.70433 10.388 8.38166 10.7043 8.10706C10.8562 7.97519 11.0683 7.85573 11.4927 7.61693L13.4347 6.52369C14.067 6.16771 14.3832 5.98973 14.5563 5.70294C14.7293 5.41615 14.7293 5.07021 14.7293 4.37831V3.91843C14.7293 3.03387 14.7293 2.59159 14.4365 2.31679C14.1435 2.04199 13.6721 2.04199 12.7293 2.04199Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1143_2168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0625 0.0419922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.9060d28f091a03ca256f405c9ca19712.svg";
export { ForwardRef as ReactComponent };